import {findParent} from '../../js/tools';

export class Accordion {
  elements = {
    root: null,
  };

  constructor(element) {
    if (!element) {
      return;
    }

    this.elements = {
      root: element,
    };

    this.addEventListeners();
    this.addTabIndexes();
  }

  addEventListeners() {
    const handleAction = () => {
      // prevent multi-clicking from selecting text
      document.getSelection()?.removeAllRanges();

      const item = findParent(event.target, '.jk-item');
      item.classList.toggle('open');
    };

    this.elements.root.addEventListener('click', (event) => {
      if (event.target.matches('.header')) {
        handleAction();
      }
    });
    this.elements.root.addEventListener('keydown', (event) => {
      if (event.target.matches('.header') && event.key === 'Enter') {
        handleAction();
      }
    });
  }

  addTabIndexes() {
    this.elements.root.querySelectorAll('.header').forEach(element => element.setAttribute('tabindex', 0));
  }
}
